<app-button-close (click)="closeNotification()"></app-button-close>

<kal-card *ngIf="countItems(activityNotificationsTypes.RECEIVABLE_SUPPLIERS_ORDERS) as count">
    <kal-card-header>
        <kal-card-title>
            Commandes fournisseurs à réceptionner
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucune commande fournisseur n'est à réceptionner. }
            one { {{ count }} commande fournisseur est à réceptionner. }
            other { {{ count }} commandes fournisseurs sont à réceptionner. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.RECEIVABLE_SUPPLIERS_ORDERS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.PAYABLE_SUPPLIERS_INVOICES) as count">
    <kal-card-header>
        <kal-card-title>
            Factures fournisseurs à solder
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucune facture fournisseur n'est à solder. }
            one { {{ count }} facture fournisseur est à solder. }
            other { {{ count }} factures fournisseurs sont à solder. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PAYABLE_SUPPLIERS_INVOICES)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.DELIVERABLE_CLIENTS_ORDERS) as count">
    <kal-card-header>
        <kal-card-title>
            Commandes clients facturées à livrer
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucune commandes clients n'est à livrer. }
            one { {{ count }} commande client qui est facturée est à livrer. }
            other { {{ count }} commandes clients qui sont facturées sont à livrer. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.DELIVERABLE_CLIENTS_ORDERS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.PENDING_CLIENTS_ORDERS) as count">
    <kal-card-header>
        <kal-card-title>
            Commandes clients en attente de validation
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucune commande client n'est en attente de validation du CSE. }
            one { {{ count }} commande client est en attente de validation du CSE. }
            other { {{ count }} commandes clients sont en attente de validation du CSE. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PENDING_CLIENTS_ORDERS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.INVOICABLE_CLIENTS_ORDERS) as count">
    <kal-card-header>
        <kal-card-title>
            Commandes clients à facturer
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucune commande client n'est à facturer. }
            one { {{ count }} commande client est à facturer. }
            other { {{ count }} commandes clients sont à facturer. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.INVOICABLE_CLIENTS_ORDERS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.PAYABLE_CLIENTS_INVOICES) as count">
    <kal-card-header>
        <kal-card-title>
            Factures clients à solder
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucune facture client en attente de règlement. }
            one { {{ count }} facture client en attente de règlement. }
            other { {{ count }} factures clients en attente de règlement. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PAYABLE_CLIENTS_INVOICES)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.STOCK_SHORTAGE_ARTICLES) as count">
    <kal-card-header>
        <kal-card-title>
            Articles en rupture de stock
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucun article n'est en rupture de stock. }
            one { {{ count }} article est en rupture de stock. }
            other { {{ count }} articles sont en rupture de stock. }}
    </kal-card-content>

<!--    TODO Mettre en place lorsque le dev sera fait-->
<!--    <kal-card-actions>-->
<!--        <kal-button kalTheme="primary">-->
<!--            Voir la liste-->
<!--        </kal-button>-->
<!--    </kal-card-actions>-->

</kal-card>

<!------------------------ PRESTATIONS ------------------------>

<kal-card *ngIf="countItems(activityNotificationsTypes.PENDING_REFUND_RECORDS) as count">
    <kal-card-header>
        <kal-card-title>
            Remboursements en attente de validation
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Aucun dossier de remboursement n'est en attente de validation. }
                one { {{ count }} dossier de remboursement est en attente de validation. }
                other { {{ count }} dossiers de remboursement sont en attente de validation. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PENDING_REFUND_RECORDS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.PENDING_PART_A_CHARGE_RECORDS) as count">
    <kal-card-header>
        <kal-card-title>
            Part à charge en attente de validation
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Aucun dossier de part à charge n'est en attente de validation. }
                one { {{ count }} dossier de part à charge est en attente de validation. }
                other { {{ count }} dossiers de part à charge sont en attente de validation. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PENDING_PART_A_CHARGE_RECORDS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.PENDING_GIFTS_RECORDS) as count">
    <kal-card-header>
        <kal-card-title>
            Cadeaux en attente de validation
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Aucun dossier de cadeaux n'est en attente de validation. }
                one { {{ count }} dossier de cadeaux est en attente de validation. }
                other { {{ count }} dossiers de cadeaux sont en attente de validation. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PENDING_GIFTS_RECORDS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.SUPPLIER_PART_A_CHARGE_RECORDS_INVOICEABLE) as count">
    <kal-card-header>
        <kal-card-title>
            Part à charge à facturer
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Aucun dossier de part à charge n'est à facturer. }
                one { {{ count }} dossier de part à charge est à facturer. }
                other { {{ count }} dossiers de part à charge sont à facturer. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.SUPPLIER_PART_A_CHARGE_RECORDS_INVOICEABLE)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>


<!--TODO: En attente de l'évolution back 47497 -->
<kal-card *ngIf="countItems(activityNotificationsTypes.GIFTS_DELIVERABLE) as count">
    <kal-card-header>
        <kal-card-title>
            Cadeaux à livrer
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucun dossier cadeaux n'est à livrer. }
            one { {{ count }} dossier cadeaux est à livrer. }
            other { {{ count }} dossiers cadeaux sont à livrer. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.GIFTS_DELIVERABLE)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>



<!------------------------ EPARGNES ------------------------>

<kal-card *ngIf="countItems(activityNotificationsTypes.PENDING_SAVINGS) as count">
    <kal-card-header>
        <kal-card-title>
            Epargnes en attente
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Aucun dossier d'épargne n'est en attente de validation. }
                one { {{ count }} dossier d'épargne est en attente de validation. }
                other { {{ count }} dossiers d'épargne sont en attente de validation. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PENDING_SAVINGS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.PROCESSABLE_SAVINGS) as count">
    <kal-card-header>
        <kal-card-title>
            Dossiers à traiter - Epargnes et/ou commandes à générer
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Aucun dossiers d'épargne n'a d'épargne et/ou de dossier à générer. }
                one { {{ count }} dossier d'épargne a une épargne et/ou un dossier à générer. }
                other { {{ count }} dossiers d'épargne ont une épargne et/ou un dossier à générer. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PROCESSABLE_SAVINGS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.PAYABLE_SAVINGS_ORDERS) as count">
    <kal-card-header>
        <kal-card-title>
            Commandes à régler
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Aucun dossier d'épargne n'est terminé et n'a des commandes à régler. }
                one { {{ count }} dossier d'épargne est terminé et a des commandes à régler. }
                other { {{ count }} dossiers d'épargne sont terminés et ont des commandes à régler. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.PAYABLE_SAVINGS_ORDERS)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<!------------------------ MEDIATHEQUE ------------------------>

<kal-card *ngIf="countItems(activityNotificationsTypes.MEDIA_OVERDUE) as count">
    <kal-card-header>
        <kal-card-title>
            Médias en retard
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Tous les médias ont été rendus à temps. }
                one { {{ count }} média n'a pas été rendu à temps. }
                other { {{ count }} médias n'ont pas été rendus à temps. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.MEDIA_OVERDUE)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.MEDIA_DELIVRABLE) as count">
    <kal-card-header>
        <kal-card-title>
            Médias à livrer
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
                =0 { Aucun média n'est à livrer. }
                one { {{ count }} média est à livrer. }
                other { {{ count }} médias sont à livrer. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.MEDIA_DELIVRABLE)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<!------------------------ RESSOURCES PARTAGEES ------------------------>

<kal-card *ngIf="countItems(activityNotificationsTypes.RESOURCE_OVERDUE) as count">
    <kal-card-header>
        <kal-card-title>
            Ressources en retard
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Toutes les ressources ont été rendues à temps. }
            one { {{ count }} ressource n'a pas été rendue à temps. }
            other { {{ count }} ressources n'ont pas été rendues à temps. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.RESOURCE_OVERDUE)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>

<kal-card *ngIf="countItems(activityNotificationsTypes.RESOURCE_DELIVRABLE) as count">
    <kal-card-header>
        <kal-card-title>
            Ressources à livrer
        </kal-card-title>
    </kal-card-header>

    <kal-card-content i18n>
        {count, plural,
            =0 { Aucune ressource n'est à livrer aujourd'hui. }
            one { {{ count }} ressource est à livrer aujourd'hui. }
            other { {{ count }} ressources sont à livrer aujourd'hui. }}
    </kal-card-content>

    <kal-card-actions>
        <kal-button kalTheme="primary"
                    (click)="navigate(activityNotificationsTypes.RESOURCE_DELIVRABLE)">
            Voir la liste
        </kal-button>
    </kal-card-actions>

</kal-card>


